import React, { useState, useEffect, useRef } from "react";
import Service from "apiService";
import Perbaikan from "./Perbaikan";

const FormPerbaikan = ({ existingPersyaratan, setStep, isShow }) => {
  const contentRef = useRef();
  const [results, setResults] = useState("");
  const [question, setquestions] = useState("");

  const getPenilaian = async () => {
    try {
      console.log(existingPersyaratan);
      const response = await Service.get(
        "/pirt/penilaian/read/" + existingPersyaratan.id
      );
      if (response) {
        console.log(response.data);
        setResults(response.data);
      }
    } catch (error) {
      setResults("");
    }
  };

  useEffect(() => {
    getPenilaian();
  }, [existingPersyaratan]);

  return (
    isShow && (
      <>
        <span
          className='text-primary mb-3 d-inline-block'
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            setStep(1);
            // setIsProgressHidden(false);
          }}>
          <i
            className='ni ni-curved-next mr-2'
            style={{
              transform: "scaleX(-1)",
            }}
          />{" "}
          <span className='d-inline'> Kembali </span>{" "}
        </span>{" "}
        <Perbaikan
          data={results || []}
          idPendaftaran={existingPersyaratan.id}
          handleSubmit={() => {}}
        />{" "}
      </>
    )
  );
};

export default FormPerbaikan;
